import { NgTemplateOutlet } from '@angular/common';
import { Component, input, output, TemplateRef } from '@angular/core';
import { Button } from '../../button/button.component';
import { Icon } from '../../icon/icon.component';

@Component({
    selector: 'ai-dialog-header',
    standalone: true,
    templateUrl: './dialog-header.component.html',
    imports: [Button, NgTemplateOutlet, Icon],
})
export class DialogHeader {
    readonly title = input<string | undefined>();
    readonly close = output<void>();
    readonly headerTemplate = input<TemplateRef<any> | undefined>();

    /**
     * Handles the close action of the dialog.
     *
     * @param _ The event that triggered the close action.
     */
    protected onClose(_: Event): void {
        this.close.emit();
    }
}
